import React, { useState } from "react";
import "./Expenses.css";
import ExpenseItem from "../ExpenseItem/ExpenseItem";
import Card from "../Card/Card";
import Form from "../Form/Form";
import FilterExpense from "../FilterExpense/FilterExpense";
import ExpensesChart from "../Chart/ExpensesChart";

function Expenses({ items, getData }) {
  const [filteredExpenses, SetFilteredExpenses] = useState([]);
  const getDataExpenses = (getExpense) => {
    getData(getExpense);
  };
  const getFilteredExpenses = (getExpenses) => {
    SetFilteredExpenses(getExpenses);
  };
  // console.log(filteredExpenses);
  return (
    <>
      <Form getData={getDataExpenses} />
      <Card className="expenses">
        <FilterExpense
          onFilterExpenses={getFilteredExpenses}
          expenses={items}
        />
        <ExpensesChart expenses={filteredExpenses} />
        {filteredExpenses.length === 0 ? <h4 className="found">No Expenses Found</h4> : filteredExpenses.map((item) => {
          return (
            <ExpenseItem
              key={item.id}
              title={item.title}
              amount={item.amount}
              date={item.date}
            />
          );
        })}
      </Card>
    </>
  );
}

export default Expenses;
